import React from 'react';
import {
  AiOutlineHome,
  AiFillHome,
  AiOutlineSetting,
  AiTwotoneSetting,
  AiFillGithub,
  AiOutlineQuestionCircle,
  AiOutlineBarChart,
} from 'react-icons/ai';
import { RiContactsFill, RiContactsLine } from 'react-icons/ri';
import { BiPhotoAlbum } from 'react-icons/bi';
import {
  SiFacebook,
  SiMathworks,
  SiAdobephotoshop,
  SiReact,
} from 'react-icons/si';
import {
  IoLanguageOutline,
  IoInvertModeOutline,
  IoServer,
} from 'react-icons/io5';
import { IoMdPhotos, IoLogoJavascript, IoLogoPython } from 'react-icons/io';
import {
  BsCode,
  BsCodeSlash,
  BsLayers,
  BsFillLayersFill,
} from 'react-icons/bs';
import { MdLayers } from 'react-icons/md';
import { ImTree } from 'react-icons/im';
import { GiBrain, GiCyberEye } from 'react-icons/gi';
import { HiOutlinePresentationChartLine } from 'react-icons/hi';
import { US, VN } from 'country-flag-icons/react/3x2';

export const vi = {
  translation: {
    leftDrawer: {
      navigations: [
        {
          path: '/',
          name: 'Trang chủ',
          icon: <AiOutlineHome />,
          activeIcon: <AiFillHome />,
        },
        {
          key: 'graphics',
          path: '/graphics',
          name: 'Đồ họa',
          icon: <BiPhotoAlbum />,
          activeIcon: <IoMdPhotos />,
        },
        {
          key: 'science',
          path: '/science',
          name: 'Science',
          icon: <BsLayers />,
          activeIcon: <BsFillLayersFill />,
        },
        {
          key: 'programing',
          path: '/programing',
          name: 'Lập trình',
          icon: <BsCode />,
          activeIcon: <BsCodeSlash />,
        },
        {
          path: '/about',
          name: 'Giới thiệu',
          icon: <RiContactsLine />,
          activeIcon: <RiContactsFill />,
        },
        {
          path: '/settings',
          name: 'Cài đặt',
          icon: <AiOutlineSetting />,
          activeIcon: <AiTwotoneSetting />,
        },
      ],
      footer: {
        contacts: [
          {
            name: 'github',
            href: 'https://github.com/mthang1801',
            icon: <AiFillGithub />,
          },
          {
            name: 'facebook',
            href: 'https://www.facebook.com/mvt.dev',
            icon: <SiFacebook />,
          },
        ],
        text: `Tất cả bản quyền @${new Date().getFullYear()} được lưu trữ | Bản thiết kế được tạo bởi MVT`,
      },
    },
    first_sub_navigation_icons: {
      javascript: <IoLogoJavascript />,
      python: <IoLogoPython />,
      mathematics: <SiMathworks />,
      photoshop: <SiAdobephotoshop />,
    },
    second_sub_navigation_icons: {
      'back-end-development': <IoServer />,
      basics: <MdLayers />,
      'data-structures-and-algorithms': <ImTree />,
      'deep-learning': <GiBrain />,
      'front-end-development': <SiReact />,
      'machine-learning': <HiOutlinePresentationChartLine />,
      opencv: <GiCyberEye />,
      'questions-interview': <AiOutlineQuestionCircle />,
      'statistics-and-probability': <AiOutlineBarChart />,
    },
    alert: {
      noPost: 'Chưa có bài viết nào.',
    },
    sidebar: {
      navigations: 'Điều hướng',
      menuNavs: {
        programing: 'Lập trình',
        graphics: 'Đồ họa',
        science: 'Khoa học Tự nhiên',
        javascript: 'Javascript',
        python: 'Python',
        mathematics: 'Toán học',
        photoshop: 'Photoshop',
        'back-end-development': 'Back-end',
        basics: 'Cơ bản',
        'data-structures-and-algorithms': 'Cấu trúc dữ liệu và giải thuật',
        'front-end-development': 'Front-end',
        'machine-learning': 'Machine Learning',
        'questions-interview': 'Câu hỏi phỏng vấn',
        'statistics-and-probability': 'Xác suất thống kê',
        opencv: 'OpenCV',
        'deep-learning': 'Deep learning',
      },
      newsLetter: {
        title: 'Hộp thư',
        subtitle: 'Mọi ý kiến đóng góp vui lòng để lại tại đây',
        namePlaceholder: 'Tên của bạn',
        emailPlaceholder: 'Email của bạn',
        feedbackPlaceholder: 'Nội dung',
        submitButton: 'Gửi đi',
      },
      popularArticles: 'Bài viết nổi bật',
      tags: 'Từ khóa tìm kiếm',
      history: 'Thống kê Bài viết',
      paragraph: 'Văn bản',
      readMore: 'Xem thêm',
      readLess: 'Rút gọn',
      tableOfContent: 'Nội dung',
    },
    datetime: {
      months: {
        1: 'Tháng Một',
        2: 'Tháng Hai',
        3: 'Tháng Ba',
        4: 'Tháng Tư',
        5: 'Tháng Năm',
        6: 'Tháng Sáu',
        7: 'Tháng Bảy',
        8: 'Tháng Tám',
        9: 'Tháng Chín',
        10: 'Tháng Mười',
        11: 'Tháng Mười Một',
        12: 'Tháng Mười Hai',
      },
    },
    posts: {
      postCard: {
        title: 'Bài viết được đề xuất',
      },
      relevantPosts: 'Bài viết có liên quan',
      postViewsUndefined: 'Đang cập nhật',
    },
    search: {
      placeholder: 'Tìm kiếm...',
      emptyResult: (searchKey) =>
        `Không tìm thấy kết quả cho từ khóa <strong>${searchKey}</strong>`,
    },
    history: {
      title: 'Lịch sử bài post',
    },
    settings: {
      title: 'Cài đặt',
      close: 'Đóng',
      languages: {
        back: 'Cài đặt',
        icon: <IoLanguageOutline />,
        label: 'Ngôn ngữ',
        subLabel: 'Lựa chọn ngôn ngữ bạn cần hiển thị',
        values: [
          { key: 'en', text: 'English', code: 'US', icon: <US /> },
          { key: 'vi', text: 'Tiếng Việt', code: 'VN', icon: <VN /> },
        ],
      },
      themes: {
        back: 'Cài đặt',
        icon: <IoInvertModeOutline />,
        label: 'Giao diện',
        subLabel: 'Lựa chọn giao diện hiển thị phù hợp với bạn.',
        values: [
          {
            key: 'light',
            text: 'Sáng',
            background: '#fff',
          },
          {
            key: 'dark',
            text: 'Tối',
            background: '#2c2c2c',
          },
        ],
      },
    },
    seo: {
      home: 'Trang chủ',
      about: 'Giới thiệu',
      pageError: 'Page Error',
      category: {
        programing: 'Lập trình',
        graphics: 'Đồ họa',
        science: 'Khoa học Tự nhiên',
      },
      firstChildCategory: {
        javascript: 'Javascript',
        mathematics: 'Toán học',
        photoshop: 'Photoshop',
        python: 'Python',
      },
      secondChildCategory: {
        'back-end-development': 'Back-end',
        basics: 'Cơ bản',
        'data-structures-and-algorithms': 'Cấu trúc dữ liệu và giải thuật',
        'front-end-development': 'Front-end',
        'machine-learning': 'Machine Learning',
        'questions-interview': 'Câu hỏi phỏng vấn',
        'statistics-and-probability': 'Xác suất thống kê',
        opencv: 'OpenCV',
        'deep-learning': 'Deep learning',
      },
    },
    about: {
      title: 'Giới thiệu',
      updatingStatus:
        'Trang đang được bảo trì hoặc cập nhật, vui lòng quay lại sau.',
    },
    tags: {
      title: 'Danh sách thẻ tags',
      specificTagTitle: (tagName) => `Kết quả tìm kiếm cho tag ${tagName}`,
    },
    page: {
      pageError:
        'Rất tiếc! Trang bạn đang tìm kiếm có thể đã bị xóa hoặc thay đổi hoặc không có sẵn.',
    },
  },
};
